// extracted by mini-css-extract-plugin
module.exports = {"container":"container_container__fOSV7","full_width":"container_full_width__9PScV"};